import { useLiveQuery } from "dexie-react-hooks";
import type { TaxonomyKind, TaxonomyApiItem } from "@recipevault/shared";
import { db } from "../../sync/db.js";

type Status = "loading" | "ready";

interface UseTaxonomyResult {
  items: TaxonomyApiItem[]; // live (non-deleted) only
  allItems: TaxonomyApiItem[]; // including soft-deleted
  status: Status;
}

export function useTaxonomy(kind: TaxonomyKind): UseTaxonomyResult {
  const all = useLiveQuery(
    async () => db.taxonomy.where("kind").equals(kind).toArray(),
    [kind],
    [] as TaxonomyApiItem[],
  );
  // `useLiveQuery` returns the default array on the first render; treat that as "loading".
  // Once Dexie resolves, the second render returns the real array.
  const status: Status = all === undefined ? "loading" : "ready";
  return {
    items: (all ?? []).filter((i) => !i.deletedAt),
    allItems: all ?? [],
    status,
  };
}
